import { ChangeDetectionStrategy, Component, forwardRef, ChangeDetectorRef} from '@angular/core';
import { WizDropItemEvent, WIZ_DRAGGABLE_COMPONENT } from '@wizeoo/akm-component-lib';
import { FIELD_KIND, EM_ACTION } from '@wizeoo/akm-compute-lib';


import { FormWidgetGridsterComponent } from '../form/generic/form-widget.gridster.component';
import { PivotField } from '../../../manager/baselines/pivot-field.obj';
import { GridsterWidgetItem } from '../../../vo/workingzone/gridster-widget-item';
import { cloneDeep } from 'lodash-es';
import { GridType } from 'angular-gridster2';

@Component({
  selector: 'freegridster',
  templateUrl:'./freegridster.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => FreeGridster),
    },
  ],
  styleUrls: ['../form/generic/form-widget.gridster.component.scss']
})
export class FreeGridster extends FormWidgetGridsterComponent {

  constructor(cdref: ChangeDetectorRef) {
    super(cdref);
  }

  /**
   * @override pour mode de rendu hors template
   */
  public updateOptions() {
    super.updateOptions();
    this.options.gridType = this.templatingMode ? GridType.Fixed : GridType.Fit; //;
  }



  onAddItemAfterDrag(pEvent: WizDropItemEvent): void {
    
    const item: GridsterWidgetItem = GridsterWidgetItem.constructFromGridster(this.gridster.emptyCell.getValidItemFromEvent(pEvent.event));
    item.field = cloneDeep(pEvent.item.data) as PivotField;
    item.source = item.field.contextItem;
    item.updateCoords();

    // TODO ici contrôle de cohérence pour supprimer les éléments anormaux
    this._widgets = [item, ...this._widgets];

    this.widgetsChanged.emit({item, action: EM_ACTION.CREATE}); //this.widgetsChanged.emit(this._widgets);

    this.cdref.markForCheck();
  }

  checkDragOver(event: WizDropItemEvent): boolean {
    
    let result: boolean = false;
    this.gridster.emptyCell.emptyCellDragOver(event.event);

    let exist: GridsterWidgetItem;
    let dropEffect: string;

    if (!event.item.data.arg || event.item.data.arg.dataType === FIELD_KIND.OBJECT) { // plusieurs fois possibles pour un champ Objet et les libellés
      result = true;
    } else {
      exist = this._widgets.find(wo => (wo.field as PivotField).code === event.item.data.code);
      dropEffect = event.event.dataTransfer.dropEffect;
      if (!exist && dropEffect !== 'none') {
        result = true;
      }
    }
    // console.log('cdo', event, exist, dropEffect);
    return result;

    
  }


}
